import React, { Fragment } from "react";
import { Table, Modal, Row, Col, Badge } from "react-bootstrap";
import PersonView from "./PersonView";
import DateRenderer from "./renderers/DateRenderer";
import moment from "moment";
import ModalPersonRenderer from "./renderers/ModalPersonRenderer";
import { SortProvider } from "../services/SortingProvider";

interface StudentSupportViewProps
{
    data: StudentSupportRecords;
}

interface StudentSupportViewState
{
    ssData: StudentSupportRecords;
    sortAsc: boolean;
    sortIcon: string;
    modalData: Person;
    showModal: boolean;
}

export default class StudentSupportView extends React.Component<StudentSupportViewProps, StudentSupportViewState>
{
    sortProvider: SortProvider

    constructor(props: StudentSupportViewProps) 
    {
        super(props);

        this.sortProvider = new SortProvider(); 

        this.sortProvider.sort(this.props.data.supportRecords, "Desc");

        this.state = {
            ssData: this.props.data,
            sortAsc: false,
            sortIcon: "fas fa-sort-down"
        };
    }

    render(): React.ReactNode 
    {
        const maxientCase = this.props.data.supportRecords.filter(itm => itm.supportSystem == "Maxient");

        const sort = (): void =>
        {
            const sortedData = this.sortProvider.sort(this.state.ssData.supportRecords, this.state.sortAsc ? "Desc" : "Asc");
            this.setState({ ssData: { supportRecords: sortedData }, sortAsc: !this.state.sortAsc, sortIcon: this.state.sortAsc ? "fas fa-sort-down" : "fas fa-sort-up" });
        };

        //Empty
        if (!this.props.data.supportRecords.length)
            return <div id='error'>
                <h2>Student Support</h2>
                <Table responsive className="list">
                    <thead>
                        <tr>
                            <th>SUPPORT SYSTEM</th>
                            <th>DATE</th>
                            <th>REFERENCE</th>
                            <th>OFFICE TEAM</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="text-center">
                            <td colSpan={4}>
                                <p className="error-text">No Support Cases</p>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>;

        return <Fragment>
            <Row>
                <Col><h2>Student Support</h2></Col>
                <Col className={"maxient-badge"}><h2 className={"float-right"}><Badge pill style={{ opacity: "0.7" }} variant="secondary">{maxientCase.length} Maxient Case(s)</Badge></h2></Col>
            </Row>
            <Table responsive className="list">
                <thead>
                    <tr>
                        <th>SUPPORT SYSTEM</th>
                        <th style={{ cursor: "pointer" }} onClick={sort}>DATE <i className={this.state.sortIcon}></i></th>
                        <th>REFERENCE</th>
                        <th>OFFICE TEAM</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        this.props.data.supportRecords.map((studentSupportRecord: StudentSupportRecord, i: number) => 
                        {
                            return <tr key={i}>
                                <td className="td-normal">{studentSupportRecord.supportSystem ? studentSupportRecord.supportSystem : " - "}</td>
                                <td className="td-normal"><DateRenderer value={studentSupportRecord.date} /></td>
                                <td>{studentSupportRecord.referenceNumber ? studentSupportRecord.referenceNumber : " - "}</td>
                                <td>{
                                    studentSupportRecord.officeTeam
                                        ?
                                        studentSupportRecord.officeTeam
                                        :
                                        <PersonView data={studentSupportRecord.reference} />
                                }</td>
                            </tr>;
                        })
                    }
                </tbody>
            </Table>
        </Fragment>;
    }
}